import { BiSolidDollarCircle } from 'react-icons/bi'
import { formatMoney } from '@/utils'

import './styles.scss'

export type PriceByProps = {
  value: number
  by?: 'kg' | 'un' | 'hundred'
  color?: string
}

export function PriceBy({ value, by, color }: PriceByProps) {
  return (
    <div className="price-by" style={{ color }}>
      <BiSolidDollarCircle color={color} />
      {value > 0 ? (
        <p>
          {formatMoney(value, true)} {by && <span>{by}</span>}
        </p>
      ) : (
        <p style={{ marginLeft: '.4rem' }}>Grátis</p>
      )}
    </div>
  )
}
